import { createElement } from "react";
/**
 * Internal Dependencies
 */
import FieldMergeTag from './field';
import AttributeMergeTag from './attribute';
import ProgressMergeTag from './progress';
import QuizMergeTag from './quiz';
import { applyFilters } from '@wordpress/hooks';
const MergeTag = ({
  type,
  modifier
}) => {
  switch (type) {
    case 'field':
      {
        return createElement(FieldMergeTag, {
          modifier: modifier
        });
      }
    case 'attribute':
      {
        return createElement(AttributeMergeTag, {
          modifier: modifier
        });
      }
    case 'progress':
      {
        return createElement(ProgressMergeTag, {
          modifier: modifier
        });
      }
    case 'quiz':
      {
        return createElement(QuizMergeTag, {
          modifier: modifier
        });
      }
    default:
      return applyFilters('QuillForms.RendererCore.MergeTag', null, type, modifier);
  }
};
export default MergeTag;
//# sourceMappingURL=index.js.map